import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { DictionaryService } from 'src/app/dictionary/dictionary.service';
import { HeaderModel } from 'src/app/_component/header/header.model';
import { HeaderService } from 'src/app/_services/header.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { ReportTask } from '../report-task.model';
import { ReportTaskService } from '../report-task.service';

@Component({
  selector: 'app-edit-report-task',
  templateUrl: './edit-report-task.page.html',
  styleUrls: [
    './edit-report-task.page.scss',
    './../../../../_styles/ion-grid-box.scss',
  ],
})
export class EditReportTaskPage implements OnInit {
  constructor(
    public reportTaskServ: ReportTaskService,
    private route: ActivatedRoute,
    private navCtrl: NavController,
    public dictionaryService: DictionaryService,
    public translateService: TranslateService,
    public p: ThisPlatform,
    private headerServ: HeaderService
  ) {}

  reportTaskId: string;
  reportId: string;
  compareWith: any;
  headerInit: HeaderModel = {
    title: 'REPORT_TASK.EDIT_TASK',
    backDefaultHref: '/app/report/report-task',
  };
  loading = true;

  isError: boolean = false;
  errorStatus: number;

  ngOnInit() {
    this.loading = true;
    this.route.paramMap.subscribe((paramMap) => {
      if (!paramMap.has('ReportTaskId')) {
        this.navCtrl.navigateBack('/report');
        return;
      }

      this.reportTaskId = paramMap.get('ReportTaskId');

      if (!paramMap.has('ReportId')) {
        this.navCtrl.navigateBack('/report');
        return;
      }
      this.reportId = paramMap.get('ReportId');

      this.reportTaskServ
        .getReportTask(this.reportTaskId)
        .toPromise()
        .then((reportTask: ReportTask) => {
          this.reportTaskServ.reportTask = reportTask;

          // this.compareWith = Utils.compareWithFn;
        })
        .catch((error) => {
          this.isError = true;
          this.errorStatus = error.status;
        });
    });
  }
  ionViewWillEnter() {
    this.headerServ.setHeaderInit(this.headerInit);
  }
  ionViewDidEnter() {
    this.loading = false;
  }
}
